module.exports = __webpack_public_path__ + "static/media/current-time.6cd49c1c.webp";